
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legends",
      function () {
        return require("private-next-pages/legends.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legends"])
      });
    }
  